import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextAI = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M25.303 18.002h2.504l-4.107-11.687h-2.855l-4.091 11.687h2.488l0.701-2.104h4.658l0.701 2.104zM20.678 13.745l1.603-4.775 1.603 4.775h-3.206z M29.91 8.652c0.735 0 1.336-0.601 1.336-1.319s-0.601-1.336-1.336-1.336c-0.718 0-1.319 0.618-1.319 1.336s0.601 1.319 1.319 1.319zM28.842 18.002h2.154v-8.348h-2.154v8.348z" }),
    width: 48,
});

export { IconTextAI };
